import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { ManageServiceRoutingModule } from './manage-service-routing.module';
import { ServiceGroupComponent } from './service-group/service-group.component';
import { ServiceComponent } from './service/service.component';
import { ManageServiceComponent } from './manage-service.component';
import { ServiceActivityComponent } from './service-activity/service-activity.component';
import { ActivityComponent } from './activity/activity.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ServiceTaxComponent } from './service-tax/service-tax.component';

@NgModule({
  declarations: [ServiceGroupComponent, ServiceComponent, ManageServiceComponent, ServiceActivityComponent, ActivityComponent, ServiceTaxComponent],
  imports: [
    DragDropModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    MyDatePickerModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ManageServiceRoutingModule,
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class ManageServiceModule { }
